import styled from 'styled-components';

export const DeleteFilterElement = styled.div`
  border-radius: 8px;
  background-color: ${(props) =>
    props.$isClearButton ? 'rgba(218, 68, 68, 0.80)' : '#27262B'};
  display: flex;
  align-items: center;
  height: 32px;
  padding: 8px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;
